





































import Vue from 'vue'

import dayjs from 'dayjs'

import { ApiService } from '@/services'
import { ReservationCategory } from '@/enums/reservationCategory'
import ReservationCard from '@/components/reservation/ReservationCard.vue'

export default Vue.extend({
  name: 'ReservationList',

  components: {
    ReservationCard,
  },

  props: {
    url: {
      type: String,
      required: true,
    },
    reservationCategory: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    reservations: null,
  }),

  mounted: function () {
    this.fetchReservations()
  },

  methods: {
    fetchReservations() {
      this.loading = true

      ApiService.get(this.url).then((response) => {
        if (response.data.length === 0) {
          this.loading = false
          this.reservations = null
          return
        }

        if (this.reservationCategory === ReservationCategory.PAST) {
          this.reservations = this.generateListData(response.data, 'voucher.requestedPeriod')
        } else {
          this.reservations = { '': response.data }
        }

        this.loading = false
      })
    },
    generateListData(rawList, indicator) {
      return rawList.reduce((reducer, reservation) => {
        const rawPath = indicator.split('.').reduce((o, p) => (o ? o[p] : ''), reservation)
        const path = this.reservationCategory === ReservationCategory.PAST ? dayjs(new Date(rawPath)).format('MMMM, YYYY') : rawPath

        if (!reducer[path]) {
          reducer[path] = []
        }

        reducer[path].push(reservation)
        return reducer
      }, {})
    },
  },
})
